import React from 'react';
import styled from "styled-components";
import LoadingIndicator from './LoadingIndicator';

const Container = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255,255,255, 0.6);
`;

interface Props {
  show: boolean;
}

export default function LoadingOverlay(props: Props) {
  const {show} = props;

  if (!show) return null;
  
  return (
    <Container>
      <LoadingIndicator size={40} />
    </Container>
  )
}